import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import DataTable from './DataTable'
import LayerActions from '../redux/layerRedux'
import MapActions from '../redux/mapRedux'
import ObjectActions from '../redux/objectRedux'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { createLinearMap } from '../utility/linearMap'

const outputMin = -1
const outputMax = 1
const inputMin = 2000
const inputMax = 3000
const linearMap = createLinearMap(inputMin, inputMax, outputMin, outputMax)

const filter = column => ['well_name', 'ndviLeaseAverage'].includes(column)
const columns = [
  { name: 'well_name', label: 'well name', format: value => value },
  {
    name: 'ndviLeaseAverage',
    label: 'ndvi',
    format: value => Number(linearMap(value)).toFixed(2),
    numeric: true
  },
  {
    name: 'ratio',
    label: 'ratio',
    format: value => Number(value).toFixed(2),
    numeric: true
  }
]

class MopraMiniTable extends PureComponent {
  handleRowClicked = event => {
    const { actions } = this.props
    const uuid = event.target.getAttribute('uuid')
    // actions.layerFilterUpdated('MopraWellsites-highlight', filter => [
    //   'in',
    //   'well_name',
    //   value
    // ])
    actions.objectToggled({ uuid })
  }

  handleZoomToObject = object => {
    const { actions } = this.props
    const { latitude, longitude } = object
    const center = [longitude, latitude]
    const zoom = [15]
    actions.centerZoomChanged(center, zoom)
  }

  handleMouseEnter = event => {
    const { actions } = this.props
    const uuid = event.target.getAttribute('uuid')
    actions.uuidsHighlighted([uuid])
  }

  handleMouseLeave = event => {
    const { actions } = this.props
    actions.uuidsHighlighted([])
  }

  render () {
    const { data, uuidsSelected, uuidsHighlighted } = this.props

    // const data = getFeaturesFromGeoJson(
    //   MopraWellsites,
    //   datum => datum.timestamp === datetime
    // )

    return (
      <Collapse component='div' in={!!data && !!data.length} unmountOnExit>
        <DataTable
          data={data}
          filter={filter}
          columns={columns}
          handleRowClicked={this.handleRowClicked}
          handleZoomToObject={this.handleZoomToObject}
          uuidsSelected={uuidsSelected}
          uuidsHighlighted={uuidsHighlighted}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      </Collapse>
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()

  const mapStateToProps = (state, ownProps) => {
    return {
      data: getData(
        state,
        'Mopra',
        getFeaturesFromGeoJson,
        datum => datum.timestamp === getDatetime(state, 'Mopra')
      ),
      datetime: getDatetime(state, 'Mopra'),
      uuidsSelected: state.object.uuidsSelected || [],
      uuidsHighlighted: state.object.uuidsHighlighted || []
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      layerFilterUpdated: (layerName, filterFunction) =>
        dispatch(LayerActions.layerFilterUpdated(layerName, filterFunction)),
      objectToggled: object => dispatch(ObjectActions.objectToggled(object)),
      centerZoomChanged: (center, zoom) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
      },
      uuidsHighlighted: uuids => dispatch(ObjectActions.uuidsHighlighted(uuids))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(
  MopraMiniTable
)



// WEBPACK FOOTER //
// ./src/tables/MopraMiniTable.js